class Helpers {
    /**
     * Utility method to extract query params from Stack Overflow
     */
    extractQueryParams = (name, url) => {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }
}

export default new Helpers()


// WEBPACK FOOTER //
// ./src/shared/Helpers.js